import { render } from "./Intake.vue?vue&type=template&id=02df6366"
import script from "./Intake.vue?vue&type=script&lang=js"
export * from "./Intake.vue?vue&type=script&lang=js"
script.render = render

export default script